import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Name: 'Name',
  InvoiceScheduleType: 'Schedule type',
  RegistrationsUntil: 'Registrations until',
  MainTask: 'Main task',
  Subtask: 'Subtask',
  AdvanceOrSettlement: 'Advance/Settlement',
  Advance: 'Advance',
  Settlement: 'Settlement',
  Amount: 'Amount',
  InvoiceText: 'InvoiceText',
  InvoiceCreationDate: 'Invoice creation date',
  UnableToDeleteScheduleInUse: "The schedule cannot be removed because it's in use",
  Save: 'Save',
  Cancel: 'Cancel',
  CreateInvoiceSchedule: 'Create invoice schedule',
  EditInvoiceSchedule: 'Edit invoice schedule',
  InvoiceScheduleInUseWarning:
    'This schedule is currently in use. Changes will be propageted to the relation schedules. All manual changes will be overriden.',
  days: 'days',
  Add: 'Add',
  AddLine: 'Add line',
  AddAdvanceLine: 'Add advance',
  AddSettlementLine: 'Add settlement',
  InvoiceSchedules: 'Invoice schedules',
  NoScheduleLines: 'No schedule lines, please add a line',
  IsTaskflowBilling: 'Taskflow billing?',
  HasTaskflowBilling: 'Has taskflow billing',

  InvoiceScheduleChangedInvoiceCreationDateWarning:
    'We changed the invoice creation date to be one day after the registration until date',
  InvoiceScheduleChangedRegistrationsUntilWarning:
    'We changed the registration until date to be one day before the invoice creation date',
  InvoiceScheduleChangesQueued:
    'Invoice schedule saved. Invoice schedules on the customers using this schedule will be updated in the background.',
  InvoiceTextForExForfaitRegistrationInvoices: 'Invoice text for separate ex forfait invoices',
  InvoiceTextForSettlementInvoices: 'Invoice text for settlements',
  InvoiceTextForNotInAdvanceRegistrationInvoices:
    'Invoice text for separate not in advance invoices',
  BasedOnReferenceYear: 'Based on reference year',
  ReferenceYear: 'Reference year',
  FiscalYearOfRegistrationUntil: 'Fiscal year based on registrations until date',
  UseReferenceYearOfTask: 'Use reference year of task',
  FiscalYearCustomerOn: 'Start year of fiscal year customer on {date}',
});

export default messages;
